import { render, staticRenderFns } from "./seekScore.vue?vue&type=template&id=646283ca&scoped=true&"
import script from "./seekScore.vue?vue&type=script&lang=js&"
export * from "./seekScore.vue?vue&type=script&lang=js&"
import style0 from "./seekScore.vue?vue&type=style&index=0&id=646283ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646283ca",
  null
  
)

export default component.exports